import { Alert, Box } from '@mui/material'
import { useTranslate } from '@tolgee/react'

export const RailVisitClosedWarning = () => {
  const { t } = useTranslate()
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Alert severity='warning'>
        {t(
          'railcarPlanningClosedWarning',
          'Railcar sequence can not be edited, since the rail visit is closed',
        )}
      </Alert>
    </Box>
  )
}
